<div class="modal-header align-items-center">
  <h5 class="h5 modal-title pull-left semibold">Add user</h5>
  <button type="button" class="btn btn-icon" aria-label="Close" (click)="onClose()">
    <i class="icon-close icon-16"></i>
  </button>
</div>
<div class="modal-body">
  <div class="flex flex-direction-column">
    <div class="form-group">
      <label class="note semibold required mb-2">User</label>
      <gcc-search-field *ngIf="!selectedUser" (clear)="onRemove()">
        <input
          class="form-control"
          maxlength="100"
          [formControl]="searchControl"
          placeholder="Search by name or email"
          [typeahead]="users$"
          typeaheadOptionField="fullName"
          [typeaheadAsync]="true"
          (typeaheadOnSelect)="onSelect($event)"
          [typeaheadItemTemplate]="userTemplate"
          [typeaheadWaitMs]="300"
          [typeaheadScrollable]="true"
          [typeaheadMinLength]="2"
          (typeaheadLoading)="typeaheadLoading($event)"
          (typeaheadNoResults)="typeaheadNoResults($event)"
        />
        <i *ngIf="isLoading" class="icon icon-spinner icon-20 icon-spinner__green"></i>
      </gcc-search-field>

      <ng-template #userTemplate let-user="item">
        <div class="d-flex py-1 mx-n3">
          <gcc-user-tile [user]="user"></gcc-user-tile>
        </div>
      </ng-template>

      <div *ngIf="noResult" class="toastrs-container">
        <div class="alert alert-danger">
          {{
            (userAlreadyExists ? 'users.messages.user_already_exist' : 'users.messages.no_results_found') | translate
          }}
        </div>
      </div>

      <div *ngIf="selectedUser" class="user user-border d-flex py-2 px-3">
        <gcc-user-tile class="flex-grow-1" [user]="selectedUser"></gcc-user-tile>
        <i (click)="onRemove()" class="icon icon-delete clickable"></i>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light m-0 mr-3" (click)="onClose()">Cancel</button>
  <button type="button" class="btn btn-primary m-0" (click)="onAdd()" [disabled]="!selectedUser">Add</button>
</div>
